import { DensityUnitEnum } from 'api';

import { SelectField, type SelectFieldProps } from '../SelectField/SelectField';

const DENSITY_UNIT_OPTIONS =
  DensityUnitEnum &&
  Object.values(DensityUnitEnum).map((densityUnit: DensityUnitEnum) => ({
    label: densityUnit,
    value: densityUnit,
  }));

type Props = Omit<SelectFieldProps, 'options'>;

export const DensityUnitSelectField = (props: Props) => {
  return <SelectField options={DENSITY_UNIT_OPTIONS} {...props} />;
};
